export const CR_PATH = {
  url: '/app/content-recommendations/details/[id]',
  param: '/app/content-recommendations/details', // last part is "/[id]", so ignore this from param
};

export const PAGE_DRAFT_PATH = {
  url: '/app/content-recommendations/content-brief/details/[id]',
  param: '/app/content-recommendations/content-brief/details',
};
